<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/5 xl:w-1/5">
        <vx-card class="overflow-hidden mb-base">
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center">
              <feather-icon icon="PackageIcon" class="p-3 inline-flex rounded-full text-secondary"></feather-icon>
              <div class="">
                <h2 class="mb-1 font-bold">{{ total_products | integer_format }}</h2>
                <span><a href="/products/list">Σύνολο Προϊόντων</a></span>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/5 xl:w-1/5">
        <vx-card class="overflow-hidden mb-base">
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center">
              <feather-icon icon="MessageSquareIcon" class="p-3 inline-flex rounded-full text-primary"></feather-icon>
              <div class="">
                <h2 class="mb-1 font-bold">{{ total_active_urls | integer_format }}</h2>
                <span><a href="/products/total_urls">Σύνολο Ενεργών Urls</a></span>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/5 xl:w-1/5">
        <vx-card class="overflow-hidden mb-base">
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center">
              <feather-icon icon="EyeIcon" class="p-3 inline-flex rounded-full text-success"></feather-icon>
              <div class="">
                <h2 class="mb-1 font-bold">{{ total_active_products_with_urls | integer_format }}</h2>
                <span><a href="/products/total_urls?enabled=1">Ενεργά Προϊόντα με Urls</a></span>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/5 xl:w-1/5">
        <vx-card class="overflow-hidden mb-base">
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center">
              <feather-icon icon="TruckIcon" class="p-3 inline-flex rounded-full text-warning"></feather-icon>
              <div class="">
                <h2 class="mb-1 font-bold">{{ total_inactive_products_with_urls | integer_format }}</h2>
                <span><a href="/products/total_urls?enabled=0"><span>Μη Ενεργά Προϊόντα με Urls</span></a></span>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/5 xl:w-1/5">
        <vx-card class="overflow-hidden mb-base">
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center">
              <feather-icon icon="MonitorIcon" class="p-3 inline-flex rounded-full text-danger"></feather-icon>
              <div class="">
                <h2 class="mb-1 font-bold">{{ total_failing_urls | integer_format }}</h2>
                <span><a href="/products/total_urls?failing=1">Προβληματικά Urls</a></span>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <div class="vx-row match-height">
      <div class="vx-col md:w-2/3 w-full mb-base">
        <vx-card title="Δείκτης τιμών σε σχέση με τον ανταγωνισμό">
          <vue-apex-charts type="line" height="350" :options="chartOptionsLineChart" :series="seriesLineChart"></vue-apex-charts>
        </vx-card>
      </div>
      <div class="vx-col md:w-1/3 w-full mb-base">
        <vx-card>
          <template slot="no-body" v-if="Object.entries(funding).length">
            <div class="p-8 clearfix">
              <div>
                <h1>
                  <span>{{ restRequests | integer_format }} <span style="font-size: 14px;"> requests</span></span>
                </h1>
                <small v-if="stats_data && stats_data.requestsPerMonth && stats_data.requestsPerMonth.hasOwnProperty('needed')">
                  <span class="text-grey">Απαιτούνται: </span>
                  <span>{{ stats_data.requestsPerMonth.needed | integer_format }} requests</span>
                </small>
              </div>

              <p v-if="stats_data && stats_data.requestsPerMonth && stats_data.requestsPerMonth.hasOwnProperty('needed') && stats_data.requestsPerMonth.needed > stats_data.requestsPerMonth.limit"
                  class="mt-2 mb-8 font-medium text-danger"
              >
                Θα χρειαστείτε άλλα {{ stats_data.requestsPerMonth.needed - stats_data.requestsPerMonth.limit | integer_format }}
             </p>
              <p v-else>&nbsp;</p>
              <hr><br>
              <div ref="stripeCard" class="form-control mt-2"></div><br>
              <vs-button icon-pack="feather" icon="icon-chevrons-right" icon-after class="shadow-md w-full" @click="askBeforeAdd">Προσθέστε 1000 requests με 10€</vs-button>
            </div>
            <div class="p-8 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0">
              <div class="mb-4">
                <small>Last Check: <b>{{ latestSearch }}</b></small>
              </div>

              <vx-card title="Υποστήριξη πελατών" title-color="#fff" content-color="#fff" class="mt-5"
                       :card-background="'linear-gradient(120deg ,rgba(109,213,237,.8), rgba(33,147,176,0.5)), url(' + card_bg_img_1 + ')'">
                <p class="mb-3">Αν αντιμετωπίζετε κάποιο τεχνικό πρόβλημα με την εφαρμογή, επικοινωνήστε μαζί μας στο <a
                    href="mailto:ticket@intelliprice.io">ticket@intelliprice.io</a>
                  ή πατήστε <a href="/support">εδώ</a> για να μας στείλετε μήνυμα μέσω της φόρμας επικοινωνίας</p>
              </vx-card>
            </div>
          </template>
        </vx-card>
      </div>
      <div class="vx-col w-full lg:w-1/2 mb-base">
        <vx-card title="Αποτελέσματα ανά πηγή">
          <div slot="no-body" v-if="productsPerSource">
            <!-- CHART -->
            <vue-apex-charts type="pie" height="340" class="my-12" :options="productsPerSource.chartOptions"
                             :series="productsPerSource.series"/>

            <ul class="mb-1">
              <li v-for="customerData in productsPerSource.analyticsData" :key="customerData.customerType"
                  class="flex justify-between py-3 px-6 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0">
                    <span class="flex items-center">
                      <span class="inline-block h-3 w-3 rounded-full mr-2" :class="`bg-${customerData.color}`"></span>
                      <span class="font-semibold">{{ customerData.name }}</span>
                    </span>
                <span>{{ customerData.counts | integer_format }}</span>
              </li>
            </ul>
          </div>

        </vx-card>
      </div>
      <div class="vx-col w-full lg:w-1/2 mb-base">
        <vx-card title="Κατάταξη βάση τιμής" v-if="productChecks">
          <!-- CHART -->
          <div slot="no-body">
            <vue-apex-charts type="radialBar" height="402" :options="productChecks.chartOptions"
                             v-if="productChecks.chartOptions"
                             :series="productChecks.series"/>
          </div>

          <!-- CHART DATA -->
          <ul class="mb-1" v-if="productChecks">
            <li v-for="orderData in productChecks.analyticsData" :key="orderData.orderType"
                class="flex mb-3 justify-between">
                  <span class="flex items-center">
                    <span class="inline-block h-4 w-4 rounded-full mr-2 bg-white border-3 border-solid"
                          :class="`border-${orderData.color}`"></span>
                    <span class="font-semibold">{{ orderData.orderType }}</span>
                  </span>
              <span>{{ orderData.actualcounts | integer_format }}</span>
            </li>
          </ul>
        </vx-card>
      </div>
      <div class="vx-col md:w-1/2 w-full mb-base" v-if="pieChartSeries.length > 1">
        <vx-card title="Κατηγορίες προϊόντων">
          <vue-apex-charts type="pie" height="350" :options="pieChartOptions" :series="pieChartSeries" v-if="pieChartSeries.length > 0"></vue-apex-charts>
        </vx-card>
      </div>
      <div class="vx-col md:w-1/2 w-full mb-base" v-if="radialBarseries.length > 1">
        <vx-card title="Brands">
          <vue-apex-charts type="pie" height="350" :options="radialBarchartOptions" :series="radialBarseries" v-if="radialBarseries.length > 0"></vue-apex-charts>
        </vx-card>
      </div>
      <div class="vx-col md:w-1/2 w-full mb-base" v-if="donutChartSeries.length > 1">
        <vx-card title="Ομάδες προϊόντων">
          <vue-apex-charts type="donut" height="350" :options="donutChartOptions" :series="donutChartSeries" v-if="donutChartSeries.length > 0"></vue-apex-charts>
        </vx-card>
      </div>
      <div class="vx-col md:w-1/2 w-full mb-base">
        <vx-card title="Έλεγχος requests">
          <template slot="actions">
            <feather-icon icon="HelpCircleIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
          </template>

          <!-- CHART -->
          <template slot="no-body">
            <div class="mt-10" v-if="requestsMeter">
              <vue-apex-charts type="radialBar" height="240" :options="requestsMeter.chartOptions"
                               :series="percentRequest"/>
            </div>
          </template>

          <!-- DATA -->
          <div class="flex justify-between text-center" slot="no-body-bottom">
            <div class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0">
              <p class="mt-4">Σύνολο</p>
              <p class="mb-4 text-3xl font-semibold" v-if="stats_data.hasOwnProperty('requestsPerMonth')">
                {{ stats_data.requestsPerMonth.limit | integer_format }}</p>
            </div>
            <div class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0">
              <p class="mt-4">Υπόλοιπα</p>
              <p class="mb-4 text-3xl font-semibold" v-if="stats_data.hasOwnProperty('requestsPerMonth')">
                {{ restRequests | integer_format }}</p>
            </div>
          </div>
          <p style="text-align: center;" v-if="stats_data && stats_data.requestsPerMonth && stats_data.requestsPerMonth.hasOwnProperty('needed')">Απαιτούνται: {{ stats_data.requestsPerMonth.needed | integer_format }}</p>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import VueApexCharts from 'vue-apexcharts'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import { StripeCheckout } from '@vue-stripe/vue-stripe';

const themeColors = ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E']
export default {
  components: {
    VueApexCharts,
    StatisticsCardLine,
    VuePerfectScrollbar
  },
  data() {
    this.publishableKey = 'pk_test_O9TXAuYMx0S3JWqECeGkcI9F005aRW0tvS';
    return {
      loading: false,
      lineItems: [
        {
          price: 'price_1LycFzG4QoXNl0tFtu5itQEC', // The id of the one-time price you created in your Stripe dashboard
          quantity: 1
        },
      ],
      userInfo: {},
      spk: 'pk_test_O9TXAuYMx0S3JWqECeGkcI9F005aRW0tvS',
      stripe: undefined,
      card: undefined,
      successURL: window.location.href,
      cancelURL: window.location.href,
      funding: {
        currBalance: 22597,
        depostis: 20065,
        comparison: {
          resultPerc: 5.2,
          pastData: 956
        },
        meta: {
          earned: {
            val: 56156,
            progress: 50
          },
          duration: {
            val: '2 Year',
            progress: 50
          }
        }
      },
      productChecks: {},
      requestsMeter: {
        chartOptions: {
          plotOptions: {
            radialBar: {
              size: 110,
              startAngle: -150,
              endAngle: 150,
              hollow: {
                size: '77%',
              },
              track: {
                background: '#bfc5cc',
                strokeWidth: '50%',
              },
              dataLabels: {
                name: {
                  show: false,
                },
                value: {
                  offsetY: 18,
                  color: '#99a2ac',
                  fontSize: '4rem',
                },
              },
            },
          },
          colors: ['#00db89'],
          fill: {
            type: 'gradient',
            gradient: {
              shade: 'dark',
              type: 'horizontal',
              shadeIntensity: 0.5,
              gradientToColors: ['#00b5b5'],
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100],
            },
          },
          stroke: {
            lineCap: 'round',
          },
          chart: {
            sparkline: {
              enabled: true,
            },
            dropShadow: {
              enabled: true,
              blur: 3,
              left: 1,
              top: 1,
              opacity: 0.1,
            },
          },
        },
      },
      products_total: 0,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      card_bg_img_1: require('@/assets/images/pages/card-bg-image-demo-1.jpg'),
    }
  },
  computed: {
    percentRequest() {
      if (this.$store.getters.getDashboardRecords && this.$store.getters.getDashboardRecords.requestsPerMonth && this.$store.getters.getDashboardRecords.requestsPerMonth.counter) {
        let res = (this.$store.getters.getDashboardRecords.requestsPerMonth.counter * 100) / this.$store.getters.getDashboardRecords.requestsPerMonth.limit
        res = Math.round((res + Number.EPSILON) * 100) / 100
        return [res]
      } else {
        return [0]
      }
    },
    restRequests() {
      if (this.$store.getters.getDashboardRecords && this.$store.getters.getDashboardRecords.requestsPerMonth && this.$store.getters.getDashboardRecords.requestsPerMonth.counter) {
        return (this.$store.getters.getDashboardRecords.requestsPerMonth.limit - this.$store.getters.getDashboardRecords.requestsPerMonth.counter)
      }
    },
    stats_data() {
      return this.$store.getters.getDashboardRecords
    },
    stats_dataRedGreen() {
      return this.$store.getters.getDashboardRecordsRedGreen
    },
    stats_dataPerSource() {
      return this.$store.getters.getDashboardRecordsPerSource
    },
    numberOfTotalProducts() {
      if (this.$store.getters.getDashboardRecords && this.$store.getters.getDashboardRecords.numberOfTotalProducts) {
        return this.$store.getters.getDashboardRecords.numberOfTotalProducts
      } else {
        return 0
      }
    },
    latestSearch() {
      if (this.$store.getters.getDashboardRecords && this.$store.getters.getDashboardRecords.latestSearch) {
        return this.$store.getters.getDashboardRecords.latestSearch
      } else {
        return ''
      }
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    },
    productsPerSource() {
      return this.$store.getters.getDashboardRecordsPerSource.productsPerSource
    },
    total_urls() {
      return this.$store.getters.getTotalUrls
    },
    total_active_urls() {
      return this.$store.getters.getActiveUrls
    },
    total_inactive_urls() {
      return this.$store.getters.getInactiveUrls
    },
    total_failing_urls() {
      return this.$store.getters.getFailingUrls
    },
    total_products() {
      return this.$store.getters.getTotalProducts
    },

    total_active_products_with_urls() {
      return this.$store.getters.getTotalActiveProductsWithUrls
    },
    total_inactive_products_with_urls() {
      return this.$store.getters.getTotalInactiveProductsWithUrls
    },

    seriesLineChart() {
      let s = []
      if (this.$store.getters.getDashboardLineChart && this.$store.getters.getDashboardLineChart.hasOwnProperty('linechart')) {
        this.$store.getters.getDashboardLineChart.linechart.forEach((obj) => {
          s.push(obj.avg_average)
        })

        return [
          {
            name: 'KPI',
            data: s
          }
        ]
      }
      return [
        {
          name: 'KPI',
          data: []
        }
      ]
    },
    chartOptionsLineChart() {
      let s = []
      if (this.$store.getters.getDashboardLineChart && this.$store.getters.getDashboardLineChart.hasOwnProperty('linechart')) {
        this.$store.getters.getDashboardLineChart.linechart.forEach((obj) => {
          s.push(obj.date)
        })
      }
      return {
        chart: {
          height: 350,
          dropShadow: {
            enabled: true,
            top: 20,
            left: 2,
            blur: 6,
            opacity: 0.20
          }
        },
        colors: ['#df87f2'],
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            inverseColors: false,
            gradientToColors: ['#7367F0'],
            shadeIntensity: 1,
            type: 'horizontal',
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100, 100, 100]
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth',
          width: 4
        },
        grid: {
          borderColor: '#ebebeb'
        },
        xaxis: {
          type: 'datetime',
          labels: {
            style: {
              cssClass: 'text-grey fill-current'
            }
          },
          axisTicks: {
            show: false
          },
          categories: s,
          axisBorder: {
            show: false
          }
        },
        yaxis: {
          tickAmount: 5,
          labels: {
            style: {
              cssClass: 'text-grey fill-current'
            },
          }
        },
        legend: {
          show: false
        },
        markers: {
          size: 0,
          hover: {
            size: 5
          }
        },
        tooltip: {
          x: { show: false }
        }
      }
    },

    pieChartSeries() {
      let s = []
      if (this.$store.getters.getDashboardProductCategories && this.$store.getters.getDashboardProductCategories.hasOwnProperty('categories')) {
        this.$store.getters.getDashboardProductCategories.categories.forEach((obj) => {
          s.push(obj.categoryCount)
        })
        return s
      }
      return []
    },
    pieChartOptions() {
      let s = []
      if (this.$store.getters.getDashboardProductCategories && this.$store.getters.getDashboardProductCategories.hasOwnProperty('categories')) {
        this.$store.getters.getDashboardProductCategories.categories.forEach((obj) => {
          s.push(obj.categoryName)
        })
        return {
          labels: s,
          colors: themeColors,
          chart: {
            offsetY: 0,
            dropShadow: {
              enabled: false,
              blur: 5,
              left: 1,
              top: 1,
              opacity: 0.2
            },
          },
          fill: {
            type: 'gradient',
            gradient: {
              gradientToColors: ['#9c8cfc', '#FFC085', '#f29292']
            }
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: 'bottom'
                }
              }
            }
          ]
        }
      }
    },

    donutChartSeries() {
      let s = []
      if (this.$store.getters.getDashboardProductGroups && this.$store.getters.getDashboardProductGroups.hasOwnProperty('groups')) {
        this.$store.getters.getDashboardProductGroups.groups.forEach((obj) => {
          s.push(obj.groupCount)
        })
        return s
      }
      return []
    },
    donutChartOptions() {
      let s = []
      if (this.$store.getters.getDashboardProductGroups && this.$store.getters.getDashboardProductGroups.hasOwnProperty('groups')) {
        this.$store.getters.getDashboardProductGroups.groups.forEach((obj) => {
          s.push(obj.groupName)
        })
        return  {
          labels: s,
          colors: themeColors,
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: 'bottom'
                }
              }
            }
          ]
        }
      }
    },

    radialBarseries() {
      let s = []
      if (this.$store.getters.getDashboardProductBrands && this.$store.getters.getDashboardProductBrands.hasOwnProperty('brands')) {
        this.$store.getters.getDashboardProductBrands.brands.forEach((obj) => {
          s.push(obj.brandCount)
        })
        return s
      }
      return []
    },
    radialBarchartOptions() {
      let s = []
      if (this.$store.getters.getDashboardProductBrands && this.$store.getters.getDashboardProductBrands.hasOwnProperty('brands')) {
        this.$store.getters.getDashboardProductBrands.brands.forEach((obj) => {
          s.push(obj.brandName)
        })
        return {
          labels: s,
          colors: themeColors,
          chart: {
            offsetY: 0,
            dropShadow: {
              enabled: false,
              blur: 5,
              left: 1,
              top: 1,
              opacity: 0.2
            },
          },
          fill: {
            type: 'gradient',
            gradient: {
              gradientToColors: ['#9c8cfc', '#FFC085', '#f29292']
            }
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: 'bottom'
                }
              }
            }
          ]
        }
      }
    },
    declineCodes() {
      return this.$store.getters.getDeclineCodes;
    },
    user() {
      return this.$store.getters.getUser
    }
  },
  methods: {
    loadData() {
      let green = 0
      let red = 0
      let white = 0

      if ((this.stats_dataRedGreen) && (this.stats_dataRedGreen.redGreenProducts) && (this.stats_dataRedGreen.redGreenProducts.hasOwnProperty('GREEN'))) {
        green = this.stats_dataRedGreen.redGreenProducts.GREEN.length
      }
      if ((this.stats_dataRedGreen) && (this.stats_dataRedGreen.redGreenProducts) && (this.stats_dataRedGreen.redGreenProducts.hasOwnProperty('RED'))) {
        red = this.stats_dataRedGreen.redGreenProducts.RED.length
      }
      if ((this.stats_dataRedGreen) && (this.stats_dataRedGreen.redGreenProducts) && (this.stats_dataRedGreen.redGreenProducts.hasOwnProperty('WHITE'))) {
        white = this.stats_dataRedGreen.redGreenProducts.WHITE.length
      }

      let greenPercent = 0
      let redPercent = 0
      let whitePercent = 0
      if (green > 0) {
        greenPercent = (green * 100) / (green + red + white)
        greenPercent = Math.round((greenPercent + Number.EPSILON) * 100) / 100
      }
      if (red > 0) {
        redPercent = (red * 100) / (green + red + white)
        redPercent = Math.round((redPercent + Number.EPSILON) * 100) / 100
      }
      if (white > 0) {
        whitePercent = (white * 100) / (green + red + white)
        whitePercent = Math.round((whitePercent + Number.EPSILON) * 100) / 100
      }

      this.products_total = red + green

      this.productChecks = {
        chartOptions: {
          labels: ['Είμαστε φθηνότεροι', 'Είμαστε ακριβότεροι','Ίδια τιμή'],
          dataLabels: {
            enabled: false,
          },
          legend: {show: false},
          chart: {
            type: 'pie',
            offsetY: 0,
            dropShadow: {
              enabled: true,
              blur: 5,
              left: 1,
              top: 1,
              opacity: 0.2,
            },
            toolbar: {
              show: false,
            },
          },
          stroke: {
            lineCap: 'round',
          },
          plotOptions: {
            radialBar: {
              size: 165,
              offsetY: -5,
              hollow: {
                size: '20%',
              },
              track: {
                background: '#ebebeb',
                strokeWidth: '100%',
                margin: 15,
              },
              dataLabels: {
                show: true,
                name: {
                  fontSize: '18px',
                },
                value: {
                  fontSize: '16px',
                  color: '#636a71',
                  offsetY: 11,
                },
                total: {
                  show: true,
                  label: 'Total',
                  formatter() {
                    return red + green + white
                  },
                },
              },
            },
          },
          responsive: [
            {
              breakpoint: 576,
              options: {
                plotOptions: {
                  radialBar: {
                    size: 150,
                    hollow: {
                      size: '20%',
                    },
                    track: {
                      background: '#ebebeb',
                      strokeWidth: '100%',
                      margin: 15,
                    },
                  },
                },
              },
            },
          ],
          colors: ['#7961F9', '#FF9F43', '#CCCCCC'],
          fill: {
            type: 'gradient',
            gradient: {
              // enabled: true,
              shade: 'dark',
              type: 'vertical',
              shadeIntensity: 0.5,
              gradientToColors: ['#9c8cfc', '#FFC085', '#CCCCCC'],
              inverseColors: false,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100],
            },
          },
        },
      }
      this.productChecks.analyticsData = [
        {
          orderType: 'Είμαστε φθηνότεροι',
          counts: greenPercent,
          color: 'primary',
          actualcounts: green,
        },
        {
          orderType: 'Είμαστε ακριβότεροι',
          counts: redPercent,
          color: 'warning',
          actualcounts: red,
        },
        {
          orderType: 'Ίδια τιμή',
          counts: whitePercent,
          color: 'info',
          actualcounts: white,
        },
      ]
      this.productChecks.series = [greenPercent, redPercent, whitePercent]
    },
    askBeforeAdd() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Επιβεβαίωση πληρωμής',
        text: `Πατώντας αποδοχή θα χρεωθεί η κάρτα που δηλώσατε 10€ για την αγορά 1000 request.`,
        accept: this.addRequests,
        acceptText: 'Αποδοχή'
      })
    },
    addRequests() {
      let vm = this

      let total = 10;
      let fname = this.user.name
      let lname = this.user.surname
      let email = this.user.email

      let payload = {
        total: total,
        description: `Αγορά IntelliPrice Requests: ${window.location.href}`
      }
      this.$store.dispatch('paymentProcess',payload).then(() => {
        console.log(vm.$store.getters.getClientSecret)
        vm.stripe.confirmCardPayment(vm.$store.getters.getClientSecret, {
          payment_method: {
            card: vm.card,
            billing_details: {
              name: fname + ' ' + lname,
              email: email,
            },
          },
        }).then((result) => {
              if (result.error) {
                let declineCode = result.error.decline_code;
                _.for(vm.declineCodes, (code) => {
                  if (code.code === declineCode) {
                    vm.$vs.notify({
                      color: 'error',
                      position: 'top-right',
                      text: code.elDescription,
                    })
                  }
                });
              } else {
                // vm.stripe = undefined
                // vm.card = undefined
                this.$store.dispatch('addRequestsToClient', result).then(() => {
                  vm.$vs.notify({
                    color: 'success',
                    position: 'top-right',
                    text: 'Τα requests προστέθηκαν με επιτυχία!',
                  })
                  vm.$store.dispatch('fetchDashboardRecords')
                })
              }
            });
      })
    },
  },
  created() {
    let vm = this
    vm.$store.dispatch('fetchDashboardRecordsRedGreen').then(() => {
      vm.loadData()
    })
    vm.$store.dispatch('fetchDashboardRecordsPerSource')
    vm.$store.dispatch('fetchDashboardRecords')
    vm.$store.dispatch('fetchDashboardLineChart')
    vm.$store.dispatch('fetchDashboardProductCategories')
    vm.$store.dispatch('fetchDashboardProductGroups')
    vm.$store.dispatch('fetchDashboardProductBrands')
  },
  mounted() {
    let vm = this
    //setInterval(function () {
    //vm.$store.dispatch('fetchDashboardRecords')
    //}, 10000);
    setTimeout(() => {
      vm.stripe = Stripe(vm.spk);
      vm.card = vm.stripe.elements().create('card');
      vm.card.mount(vm.$refs.stripeCard);
    }, "1000")
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.$store.dispatch('fetchUser', this.userInfo.uid)
  },
  beforeMount(){
    //Place Stripe script to the dom.
    let externalScript = document.createElement('script');
    externalScript.setAttribute('src', 'https://js.stripe.com/v3/');
    document.head.appendChild(externalScript);
  },
}
</script>

<style lang="scss">
.chat-card-log {
  height: 400px;

  .chat-sent-msg {
    background-color: #f2f4f7 !important;
  }
}
</style>
